var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.subscription && _vm.subscription.plan)?_c('span',[_vm._v(_vm._s(_vm.subscription.plan.name))]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.statusDisplay)?_c('span',{staticClass:"subscription-status-tag",style:(_vm.tagStyle)},[_vm._v(_vm._s(_vm.statusDisplay))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }